import Stretch from '../Stretches/Stretch';
import { StretchPrice } from '../Stretches/StretchPrice';
export default class CollaboratorStretch extends Stretch {
    constructor(props) {
        super(props);
        if (props.disabled_at) {
            this.disabled_at = new Date(props.disabled_at);
        }
        if (props.prices) {
            // para un servicio en colaboración si no tiene priceNet no permito que sea un precio válido
            this.prices = props.prices.filter(price => (price.price && price.price >= 0 && price.priceNet && price.priceNet >= 0)).map((value) => new StretchPrice(value));
        }
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/modules/CollaboratorStretches/CollaboratorStretch.ts
// module id = 59
// module chunks = 0